import { EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./auth.service";
var TaskWarningsService = /** @class */ (function () {
    function TaskWarningsService(http, authService) {
        this.http = http;
        this.authService = authService;
        this.onEditEvent = new EventEmitter();
    }
    TaskWarningsService.prototype.getTaskWarningList = function (params) {
        return this.http.get(environment.apiUrl + "/" + this.authService.getUserType() + "/tasks/warning", { params: params })
            .pipe(map(function (res) { return res; }));
    };
    TaskWarningsService.prototype.createTaskWarning = function (taskWarning) {
        return this.http.post(environment.apiUrl + "/" + this.authService.getUserType() + "/tasks/warning", taskWarning).pipe(map(function (res) { return res; }));
    };
    TaskWarningsService.prototype.deleteTaskWarning = function (taskWarningId) {
        return this.http.delete(environment.apiUrl + "/" + this.authService.getUserType() + "/tasks/warning/" + taskWarningId);
    };
    TaskWarningsService.ngInjectableDef = i0.defineInjectable({ factory: function TaskWarningsService_Factory() { return new TaskWarningsService(i0.inject(i1.HttpClient), i0.inject(i2.AuthService)); }, token: TaskWarningsService, providedIn: "root" });
    return TaskWarningsService;
}());
export { TaskWarningsService };
